import { BoundedBuffer, buildCookieOptions, checkCookiesAuthorized, checkIsNotLocalFile, createContextManager, deepClone, defineGlobal, ErrorSource, getGlobalObject, isPercentage, makeGlobal, monitor, } from '@datadog/browser-core';
import { ActionType } from '../domain/rumEventsCollection/action/trackActions';
import { startRum } from './rum';
export var datadogRum = makeRumGlobal(startRum);
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);
export function makeRumGlobal(startRumImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = createContextManager();
    var getInternalContextStrategy = function () {
        return undefined;
    };
    var beforeInitAddAction = new BoundedBuffer();
    var addActionStrategy = function (action) {
        beforeInitAddAction.add([action, deepClone(globalContextManager.get())]);
    };
    var beforeInitAddError = new BoundedBuffer();
    var addErrorStrategy = function (providedError) {
        beforeInitAddError.add([providedError, deepClone(globalContextManager.get())]);
    };
    var rumGlobal = makeGlobal({
        init: monitor(function (userConfiguration) {
            var _a;
            if (!checkCookiesAuthorized(buildCookieOptions(userConfiguration)) ||
                !checkIsNotLocalFile() ||
                !canInitRum(userConfiguration)) {
                return;
            }
            if (userConfiguration.publicApiKey) {
                userConfiguration.clientToken = userConfiguration.publicApiKey;
            }
            ;
            (_a = startRumImpl(userConfiguration, globalContextManager.get), addActionStrategy = _a.addAction, addErrorStrategy = _a.addError, getInternalContextStrategy = _a.getInternalContext);
            beforeInitAddAction.drain(function (_a) {
                var action = _a[0], context = _a[1];
                return addActionStrategy(action, context);
            });
            beforeInitAddError.drain(function (_a) {
                var error = _a[0], context = _a[1];
                return addErrorStrategy(error, context);
            });
            isAlreadyInitialized = true;
        }),
        addRumGlobalContext: monitor(globalContextManager.add),
        removeRumGlobalContext: monitor(globalContextManager.remove),
        getRumGlobalContext: monitor(globalContextManager.get),
        setRumGlobalContext: monitor(globalContextManager.set),
        getInternalContext: monitor(function (startTime) {
            return getInternalContextStrategy(startTime);
        }),
        addAction: monitor(function (name, context) {
            addActionStrategy({
                name: name,
                context: deepClone(context),
                startTime: performance.now(),
                type: ActionType.CUSTOM,
            });
        }),
        addUserAction: function (name, context) {
            // TODO deprecate in v2
            rumGlobal.addAction(name, context);
        },
        addError: monitor(function (error, context, source) {
            if (source === void 0) { source = ErrorSource.CUSTOM; }
            var checkedSource;
            if (source === ErrorSource.CUSTOM || source === ErrorSource.NETWORK || source === ErrorSource.SOURCE) {
                checkedSource = source;
            }
            else {
                console.error("DD_RUM.addError: Invalid source '" + source + "'");
                checkedSource = ErrorSource.CUSTOM;
            }
            addErrorStrategy({
                error: error,
                context: deepClone(context),
                source: checkedSource,
                startTime: performance.now(),
            });
        }),
    });
    return rumGlobal;
    function canInitRum(userConfiguration) {
        if (isAlreadyInitialized) {
            if (!userConfiguration.silentMultipleInit) {
                console.error('DD_RUM is already initialized.');
            }
            return false;
        }
        if (!userConfiguration || (!userConfiguration.clientToken && !userConfiguration.publicApiKey)) {
            console.error('Client Token is not configured, we will not send any data.');
            return false;
        }
        if (!userConfiguration.applicationId) {
            console.error('Application ID is not configured, no RUM data will be collected.');
            return false;
        }
        if (userConfiguration.sampleRate !== undefined && !isPercentage(userConfiguration.sampleRate)) {
            console.error('Sample Rate should be a number between 0 and 100');
            return false;
        }
        if (userConfiguration.resourceSampleRate !== undefined && !isPercentage(userConfiguration.resourceSampleRate)) {
            console.error('Resource Sample Rate should be a number between 0 and 100');
            return false;
        }
        if (Array.isArray(userConfiguration.allowedTracingOrigins) &&
            userConfiguration.allowedTracingOrigins.length !== 0 &&
            userConfiguration.service === undefined) {
            console.error('Service need to be configured when tracing is enabled');
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=rum.entry.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/esm/boot/rum.entry.js
// module id = 6SlK
// module chunks = 1